module.exports = __webpack_public_path__ + "img/mapper-skipped.f2c6a5e.png";